import { render, staticRenderFns } from "./AvenantGenerator.vue?vue&type=template&id=2283ed70&scoped=true"
import script from "./AvenantGenerator.vue?vue&type=script&lang=ts"
export * from "./AvenantGenerator.vue?vue&type=script&lang=ts"
import style0 from "./AvenantGenerator.vue?vue&type=style&index=0&id=2283ed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283ed70",
  null
  
)

export default component.exports